import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ExportRequiredDataModel } from '@seahorse/domain';
import {
  ShButtonComponent,
  ShFieldComponent,
  ShInputComponent,
  ShToggleComponent,
} from '@seahorse/components';
import { CsvInputComponent } from '../csv-input/csv-input.component';

/**
 * The "required data" items of an overview or details configuration: one card
 * per item (mapping key, field, output, multiple, requested fields) and an
 * add button. Edits the items in place (`[(items)]`); adding and removing
 * emit a new list.
 */
@Component({
  selector: 'su-required-data-editor',
  templateUrl: './required-data-editor.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    ShButtonComponent,
    ShFieldComponent,
    ShInputComponent,
    ShToggleComponent,
    CsvInputComponent,
  ],
})
export class RequiredDataEditorComponent {
  @Input() items: ExportRequiredDataModel[] | null = [];
  @Output() itemsChange = new EventEmitter<ExportRequiredDataModel[]>();

  add() {
    const item: ExportRequiredDataModel = {
      mappingKey: null,
      multiple: null,
      output: null,
      field: null,
      requestedFields: [],
    };

    this.itemsChange.emit([...(this.items ?? []), item]);
  }

  remove(index: number) {
    this.itemsChange.emit((this.items ?? []).filter((_, i) => i !== index));
  }
}
